export default (
  value,
  suffix = '',
  prefix = '',
  locale = 'nl-NL',
  minFractionDigits = 0,
  maxFractionDigits = 0,
) => {
  if (isNaN(value)) return value;
  const formattedValue = Number(value).toLocaleString(locale, {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  });
  if (locale === 'en-US' || locale === 'en-GB')
    return `${prefix} ${formattedValue}${suffix}`.trim();
  else return `${prefix} ${formattedValue}${suffix}`.trim();
};
